<template>
    <div style="height: 100%;">
        <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
            <h3 style="margin-bottom: 0;">区域列表</h3>
        </div>
        <!-- 区域名称搜索输入框和新增按钮 -->
        <div style="margin-bottom: 10px; display: flex; gap: 10px;" v-if="isEditModel">

            <el-button type="primary" size="small" @click="openAddArea">
                <i class="el-icon-plus"></i> 新增
            </el-button>
        </div>
        <el-table v-if="isListModel" :data="pagedAreaList" style="width: 100%; cursor: pointer;" border
            height="calc(100% - 80px)" max-height="calc(100% - 80px)" @row-click="handleAreaRowClick">

            <el-table-column prop="areaID" label="序号" width="50" align="center"></el-table-column>

            <el-table-column prop="left" label="左上角" align="center">
                <template slot-scope="scope">
                    {{ scope.row.dwLeftTopLat + ',' + scope.row.dwLeftTopLon }}
                </template>
            </el-table-column>
            <el-table-column prop="right" label="右下角" align="center">
                <template slot-scope="scope">
                    {{ scope.row.dwRightBotLat + ',' + scope.row.dwRightBotLon }}
                </template>
            </el-table-column>
            <el-table-column prop="slope" label="坡度" width="80" align="center"></el-table-column>
            <!-- 操作列 -->
            <el-table-column label="操作" width="160" fixed="right" v-if="isEditModel">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.stop="openEditArea(scope.row)">
                        <i class="el-icon-edit"></i> 编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.stop="deleteArea(scope.row)">
                        <i class="el-icon-delete"></i> 删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div v-if="isListModel" style="margin-top: 10px; display: flex; justify-content: flex-end;">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, prev, pager, next" :total="areaList.length">
            </el-pagination>
        </div>
        <!-- 区域编辑弹窗 -->
        <area-edit v-if="!isListModel" ref="areaEditRef" :map="map" @cancelEdit="cancelEditArea"
            @save="saveArea"></area-edit>
        <!-- 
            :areaFormData="areaFormData"      -->
    </div>
</template>
<script>

import AreaEdit from './area_edit.vue'
export default {
    name: "AreaList",
    components: {
        AreaEdit,
    },
    props: {

        selectedRoute: {
            type: Object,
            default: () => { },
        },
        map: {
            type: Object,
            default: () => { },
        },
        isEditModel: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        selectedRoute: {
            handler(newVal, oldVal) {
                if (newVal && newVal.routeID !== oldVal?.routeID) {
                   
                }
            },
            deep: true,
        },
    },
    computed: {
        // 根据选中线路和搜索关键词过滤的区域列表

        // 分页处理后的区域列表
        pagedAreaList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.areaList.slice(start, end);
        }
    },
    data() {
        return {
            areaDialogLoading: false,
            isListModel: true,//列表模式，
            areaSearchKeyword: "",
            currentPage: 1,
            pageSize: 10,
            areaList: [],
            currentArea: undefined,


        }
    },
    mounted() {

    },
    methods: {
         //获取区域列表，用于线路保存的时候用
        getAreaList() {           
            return this.areaList || [];
        },
        // 保存区域
        saveArea(data) {

            this.isListModel = true;
            // data.areaID 从 areaList 的areaID最大值加1
            if (data.areaID && data.areaID > 0) {
                //编辑的模式

                const index = this.areaList.findIndex(item => item.areaID === data.areaID);

                if (index !== -1) {
                    //更新页面表格
                    this.$set(this.areaList, index, Object.assign({}, data));
                }
                //页面表格没有更新

            }
            else {
                if (this.areaList.length > 0) {
                    data.areaID = Math.max(...this.areaList.map(item => parseInt(item.areaID)), 0) + 1;
                } else {
                    data.areaID = 1;
                }
                //列表增加数据
                this.areaList.push(data);
            }

            //地图显示
            this.showAreaOnMap();
        },
        // 删除区域
        deleteArea(row) {
            this.$confirm(`确定要删除区域吗？`, '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除区域
                const index = this.areaList.findIndex(item => item.areaID === row.areaID);
                if (index !== -1) {
                    this.areaList.splice(index, 1);
                    //地图删除
                    this.map.removePolygonById(row.areaID);

                    this.$message.success('区域删除成功');
                }
            }).catch(() => {
                // 取消删除
            });
        },
        //设置区域列表，从外部传入线路列表
        setAreaList(data) {
            this.areaList = data || [];
            this.currentPage = 1;
            this.showAreaOnMap();

        },
        //显示点击选中的区域
        handleAreaRowClick(row) {
            var areaId = 9999;
            //切换区域时，先移除旧的多边形
            if (this.currentArea) {
                this.currentArea = undefined;
                this.map.removePolygonById(areaId);
            }

            if (!this.map) {
                return;
            }


            this.currentArea = row;
            const coordinates = [
                { lng: row.dwLeftTopLon, lat: row.dwLeftTopLat }, // 左上角
                { lng: row.dwRightBotLon, lat: row.dwLeftTopLat }, // 右上角
                { lng: row.dwRightBotLon, lat: row.dwRightBotLat }, // 右下角
                { lng: row.dwLeftTopLon, lat: row.dwRightBotLat } // 左下角
            ];
            this.map.addPolygon(
                areaId, // 区域ID
                "area_" + areaId, // 区域名称
                coordinates, // 坐标数组
                2, // 线条宽度
                '#1890ff', // 线条颜色
                '#FF0000' // 填充颜色（带透明度）
            );

        },
        // 加载区域列表
       
        showAreaOnMap() {
            if (!this.map) {
                this.$message.error('地图加载未完成，请稍后再试');
                return;
            }
            this.map.clearOverlay();
            if (!this.map || !this.areaList || this.areaList.length === 0) {
                return;
            }

            // 遍历区域列表，绘制每个矩形区域

            this.areaList.forEach(area => {
                // 构造矩形的四个顶点坐标（左上角、右上角、右下角、左下角）

                const coordinates = [
                    { lng: area.dwLeftTopLon, lat: area.dwLeftTopLat }, // 左上角
                    { lng: area.dwRightBotLon, lat: area.dwLeftTopLat }, // 右上角
                    { lng: area.dwRightBotLon, lat: area.dwRightBotLat }, // 右下角
                    { lng: area.dwLeftTopLon, lat: area.dwRightBotLat } // 左下角
                ];

                // 绘制矩形区域（使用addPolygon方法）
                this.map.addPolygon(
                    area.areaID, // 区域ID
                    "area_" + area.areaID, // 区域名称
                    coordinates, // 坐标数组
                    2, // 线条宽度
                    '#1890ff', // 线条颜色
                    '#1890ff88' // 填充颜色（带透明度）
                );

            });


        },
        //开启新增区域的界面
        openAddArea() {
            this.isListModel = false;//进去区域编辑
            //清空地图内容
            if (this.map) {
                this.map.clearOverlay();
            }
            //重置数据
            this.$nextTick(() => {
                this.$refs.areaEditRef.add();
            }); 

        },
        //取消区域编辑
        cancelEditArea() {

            this.isListModel = true;

            this.showAreaOnMap();
        },
        //开启区域编辑
        openEditArea(area) {
            // this.$emit("editClick", area);
            this.isListModel = false;//进去区域编辑
            this.$nextTick(() => {
                this.$refs.areaEditRef.edit(area);
            });

        },

        // 分页相关方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        }
    }
}
</script>